<template>
  <button class="button" :class="type" type="button" :disabled="disabled">
    {{ text }}
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'ghost'].indexOf(value) !== -1;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Button.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Button/Button.vue